// Persist these references in source. Runtime URLs belong only to the host session.
export const assetIds = (source: string): string[] => Array.from(new Set(
  Array.from(source.matchAll(/unity-asset:([0-9a-f]{64})/g), match => match[1]))).sort();
export const replaceAssets = (source: string, urls: Record<string, string>): string =>
  source.replace(/unity-asset:([0-9a-f]{64})/g, (_, id) => urls[id] || 'data:,');
